import Alert from "react-s-alert";
import {I18nUtils} from "../../../i18n/I18nUtils";
import AddTypeDocumentRequest from "../ws/AddTypeDocumentRequest";
import TypeDocumentRequest from "../ws/TypeDocumentRequest";
import TypeDocumentsRequest from "../ws/TypeDocumentsRequest";
import FileTypeRequest from "../ws/FileTypeRequest";
import {push} from "react-router-redux";
import UpdateTypeDocumentRequest from "../ws/UpdateTypeDocumentRequest";
import {PsRoutes} from "../../shared/routing/Routes";
import {reset} from 'redux-form';

export const TYPEDOCUMENT_UPDATE = 'typedocument-update';
export const TYPEDOCUMENTS_UPDATE = 'typedocuments-update';
export const TYPEDOCUMENT_LOADING = 'typedocument-loading';
export const TYPEDOCUMENT_ERROR = 'typedocument-error';
export const TYPEDOCUMENT_STATE_UPDATE = 'typedocument-state-update';

export const TYPEDOCUMENT_ADD_LOADING = 'typedocument-add-loading';
export const FILE_TYPE_UPDATE = 'filetype-update';
export const TYPEDOCUMENT_ADD_SUCCESS = 'typedocument-add-success';
export const TYPEDOCUMENT_SCHEMA = 'typedocument-schema';

export const changeSchema = (schema) => ({
    type: TYPEDOCUMENT_SCHEMA,
    payload: schema,
});

export const addTypeDocument = (typedocument = {}) => (dispatch) => {

    new AddTypeDocumentRequest(typedocument)
        .onPreExecution(() => {
            dispatch({ type: TYPEDOCUMENT_ADD_LOADING, payload: true });
        })
        .onSuccess(data => {
            Alert.success(I18nUtils.tr('TR_ADD_TYPEDOCUMENT_SUCCESS'));
            dispatch({ type: TYPEDOCUMENT_ADD_SUCCESS, payload: data });
            dispatch(reset('TypeDocumentsCreateForm'));
        })
        .onFail(error => {
            Alert.error(error || I18nUtils.tr('TR_ADD_TYPEDOCUMENT_ERROR'));
        })
        .onPostExecution(() => {
            dispatch({ type: TYPEDOCUMENT_ADD_LOADING, payload: false });
        })
        .execute();
};

export const getTypeDocuments = (page = 1, search = '', filter = 0) => (dispatch) => {

    new TypeDocumentsRequest(page, search, filter)
        .onPreExecution(() => {
            dispatch({ type: TYPEDOCUMENT_LOADING, payload: true });
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: TYPEDOCUMENTS_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({ type: TYPEDOCUMENT_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: TYPEDOCUMENT_LOADING, payload: false });
        })
        .execute();
};

export const getFileTypes = () => (dispatch) => {
    new FileTypeRequest()
        .onPreExecution(() => {
            dispatch({ type: TYPEDOCUMENT_ADD_LOADING, payload: true });
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: FILE_TYPE_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({ type: TYPEDOCUMENT_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: TYPEDOCUMENT_ADD_LOADING, payload: false });
        })
        .execute();
};

export const getTypeDocument = (id) => (dispatch) => {
    new TypeDocumentRequest(id)
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: TYPEDOCUMENT_UPDATE,
                payload: data,
            });
        })
        .execute();
};

export const updateTypeDocument = (typedocument = {}) => (dispatch) => {
    new UpdateTypeDocumentRequest(typedocument.id, typedocument)
        .onPreExecution(() => {
            dispatch({ type: TYPEDOCUMENT_ADD_LOADING, payload: true });
        })
        .onSuccess(data => {
            Alert.success(I18nUtils.tr('TR_UPDATE_TYPEDOCUMENT_SUCCESS'));
            dispatch(push(PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES));
        })
        .onFail(error => {
            Alert.error(error || I18nUtils.tr('TR_UPDATE_TYPEDOCUMENT_ERROR'));
        })
        .onPostExecution(() => {
            dispatch({ type: TYPEDOCUMENT_ADD_LOADING, payload: false });
        })
        .execute();
};



// WEBPACK FOOTER //
// ./src/app/documents/actions/typeDocumentsActions.js